import { SAVE_LIVE_STATUS } from "../../actions/liveStatus/liveStatusActions";

const initialState = {
  isLive: null,
};

const liveStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SAVE_LIVE_STATUS:
      let liveStatus = action.payload;
      // Convert string "true"/"false" to boolean
      if (typeof liveStatus === "string") {
        liveStatus = liveStatus.toLowerCase() === "true";
      }
      // Only update if the value is boolean (after conversion)
      if (typeof liveStatus === "boolean") {
        return {
          ...state,
          isLive: liveStatus,
        };
      }
      return state; // Return the existing state if the payload is invalid
    default:
      return state;
  }
};


export default liveStatusReducer;